export default function (context) {
    context.dispatch('user/get', {});
}